import { render, staticRenderFns } from "./ScoreboardReport.vue?vue&type=template&id=89d3b594"
import script from "./ScoreboardReport.vue?vue&type=script&lang=js"
export * from "./ScoreboardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports